module.exports = __webpack_public_path__ + "static/media/wesley.f552f0bc.png";